module.exports = __webpack_public_path__ + "static/media/ODS8.e04819bc.svg";